<template>
  <div class="screen-blocks">
    <div class="screen-blocks--title">
      {{ $$FormData.title }}
    </div>
    <div class="screen-blocks--gird" :class="[`style_${$$FormData.style}`]">
      <div v-for="item in $$FormData.blocks" :key="item.__key" class="gird-item">
        <div class="gird-item-inner">
          <div class="icon-item">
            <img v-if="item.image" :src="item.image.src" class="icon-item-img" :alt="item.title"/>
          </div>
          <div class="title-item">{{ item.title }}</div>
          <div class="subtitle-item">{{ item.sub_title }}</div>
        </div>
      </div>
      <div v-if="!$$FormData.blocks.length" class="screen-blocks--gird-empty">请添加Block</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScreenBlocksPreview'
}
</script>

<style lang="scss" scoped>
.screen-blocks {
  width: 100%;
  &--title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1210px;
    margin: 0 auto;
    color: #011627;
    font-size: 34px;
    line-height: 1.4;
    font-weight: bold;
    padding: 10px;
  }
  &--gird {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    margin: 10px auto 0;
    &-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100px;
      color: #999999;
      font-size: 24px;
    }
  }
  .gird-item {
    width: 390px;
    padding: 40px;
    background-color: #ffffff;
    box-sizing: border-box;
    border-radius: 10px;
    transition: all .2s ease-out;
    &:hover {
      box-shadow: 0 0 10px rgba(0, 0, 0, .2);
    }
    &-inner {
      width: 100%;
    }
    .icon-item {
      width: 42px;
      height: 42px;
      padding-bottom: 10px;
      .icon-item-img {
        width: 100%;
        height: 100%;
      }
    }
    .title-item {
      color: #011627;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.5;
      margin-top: 15px;
      margin-bottom: 20px;
    }
    .subtitle-item {
      color: rgba(1, 22, 39, 0.75);
      font-size: 15px;
      font-weight: 400;
      line-height: 1.8;
    }
  }
  &--gird.style_4 {
    row-gap: 20px;
    column-gap: 35px;
    .gird-item {
      width: calc((100% - 105px) / 4);
      padding: 10px;
      .icon-item {
        width: 100%;
        height: 184px;
        margin-bottom: 15px;
      }
      .title-item {
        margin-top: 0;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
